"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _fastMarquee = _interopRequireDefault(require("../../product-merchandising/template-wall-section/common/fast-marquee"));
var _section = _interopRequireDefault(require("@site/pattern-library-core/section"));
var _tickerItem = _interopRequireDefault(require("./ticker-item"));
var _intents = _interopRequireWildcard(require("@site/pattern-library-utils/intents"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const TickerContainer = /*#__PURE__*/(0, _react2.styled)(_section.default)({
  name: "TickerContainer",
  class: "pl-t1w3f4zj",
  vars: {
    "t1w3f4zj-1": [({
      variant
    }) => variant === 'in-page' ? 'var(--viewport-space--300)' : '0'],
    "t1w3f4zj-2": [({
      variant
    }) => variant === 'in-page' ? `1rem` : '0'],
    "t1w3f4zj-3": [({
      backgroundColor
    }) => backgroundColor ? backgroundColor : `${_intents.default.ux.feedbackHighlight.feedbackColor}`]
  }
});
const TickerInner = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "TickerInner",
  class: "pl-tcia14r"
});
const TickerCopy = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "TickerCopy",
  class: "pl-t1jixp2h"
});
const TickerItemWrapper = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "TickerItemWrapper",
  class: "pl-tzf0klc"
});

/**
 * RTBTicker component renders a ticker with a marquee effect.
 *
 * @param {Object} props Component props
 * @param {string} props.id Unique identifier for the ticker
 * @param {string} props._name Name of the ticker
 * @param {Array} props.items List of items to display in the ticker
 * @param {string} props.direction Direction of the ticker movement ('left' or 'right')
 * @param {number} props.speed Speed of the ticker movement
 * @param {string} props.verticalMargin Vertical margin for the ticker
 * @param {string} props.partial Partial style for the ticker
 * @param {string} props.backgroundColor Background color of the ticker
 * @returns {JSX.Element|null} RTBTicker component or null if no items are provided
 */
function RTBTicker({
  id,
  _name,
  items,
  direction = 'left',
  speed = 50,
  verticalMargin,
  partial,
  backgroundColor,
  variant = 'full-width'
}) {
  if (!items || items.length === 0) {
    return null;
  }
  return /*#__PURE__*/_react.default.createElement(TickerContainer, {
    id: `id-${id}`,
    _name: _name,
    dataCy: "rtb-ticker",
    padding: "none",
    verticalMargin: verticalMargin,
    partial: partial || 'light1',
    backgroundColor: (0, _intents.getBackgroundColor)(backgroundColor),
    variant: variant
  }, /*#__PURE__*/_react.default.createElement(TickerInner, null, /*#__PURE__*/_react.default.createElement(_fastMarquee.default, {
    direction: direction,
    speed: speed,
    pauseOnHover: true,
    pauseOnClick: false,
    play: true
  }, /*#__PURE__*/_react.default.createElement(TickerCopy, null, [...Array(3)].map((_, copyIndex) => items.map((item, idx) => /*#__PURE__*/_react.default.createElement(TickerItemWrapper, {
    key: `${copyIndex}-${idx}`
  }, /*#__PURE__*/_react.default.createElement(_tickerItem.default, (0, _extends2.default)({}, item, {
    index: idx
  })))))))));
}
var _default = exports.default = RTBTicker;
RTBTicker.propTypes = {
  direction: _propTypes.default.oneOf(['left', 'right']),
  variant: _propTypes.default.oneOf(['full-width', 'in-page']),
  speed: _propTypes.default.number,
  items: _propTypes.default.arrayOf(_propTypes.default.shape({
    text: _propTypes.default.string.isRequired,
    icon: _propTypes.default.string
  })),
  ..._patternLibraryUtils.marginProps,
  ..._patternLibraryUtils.paddingProps
};